// extracted by mini-css-extract-plugin
export default {"seo":"qKjQG","white-60":"mlAqM","white-80":"S_ZbN","seo_button":"axa7Y","seo_expanded":"FROhy"};